import { useState, useEffect } from "react";
import { t, limparVocab, ehSegmentoClinica } from "./vocab";
import { marca, marcaSync, limparMarca } from "./marca";
import { ThemeProvider, useTheme } from "./components/Theme";
import { getPerfil } from "./components/Permissoes";
import { useNotificacoes, NotificacaoToast } from "./components/Notificacoes";
import Login          from "./pages/Login";
import Signup         from "./pages/Signup";
import FunilConfig    from "./pages/FunilConfig";
import SinoAvisos     from "./components/SinoAvisos";
import PainelMaster, { VoltarMaster } from "./pages/PainelMaster";
import Kanban         from "./pages/Kanban";
import Leads          from "./pages/Leads";
import Dashboard      from "./pages/Dashboard";
import Clientes       from "./pages/Clientes";
import Usuarios       from "./pages/Usuarios";
import Configuracoes  from "./pages/Configuracoes";
import Calendario     from "./pages/Calendario";
import PainelVendas   from "./pages/PainelVendas";
import Negociacoes    from "./pages/Negociacoes";
import Projetos       from "./pages/Projetos";
import Atividades     from "./pages/Atividades";
import Financeiro     from "./pages/Financeiro";
import Relatorios     from "./pages/Relatorios";
import Orcamentos     from "./pages/Orcamentos";
import Produtos       from "./pages/Produtos";
import Pacotes        from "./pages/Pacotes";
import Integracoes    from "./pages/Integracoes";
import Faltas         from "./pages/Faltas";
import Espera         from "./pages/Espera";
import Prontuarios from "./pages/Prontuarios";
import Privacidade    from "./pages/Privacidade";
import Painel         from "./pages/Painel";
import Agenda         from "./pages/Agenda";
import Historico      from "./pages/Historico";
import Gestao         from "./pages/Gestao";
import Comissoes     from "./pages/Comissoes";
import FinancaPessoal from "./pages/FinancaPessoal";
import RH             from "./pages/RH";
import { Users, Users2, LayoutGrid, DollarSign, FolderKanban, UserCheck, Calendar, LayoutDashboard, CreditCard, Trophy, Settings, ListChecks, BarChart3 , FileText, Package, History, Gauge, Percent, Wallet, Shield, Layers, Link2, CalendarX, Hourglass, ShieldCheck, Activity, UserCog , Stethoscope} from "lucide-react";

const NAV_SECTIONS = [
  {
    label: "Vendas",
    items: [
      { id:"leads",       label:"Leads",        icon:Users },
      { id:"negociacoes", label:"Negociações",   icon:DollarSign },
    ]
  },
  {
    label: "Gestão",
    items: [
      { id:"orcamentos", label:"Orçamentos",   icon:FileText },
      { id:"projetos",   label:"Projetos",      icon:FolderKanban },
      { id:"produtos",   label:"Produtos",     icon:Package },
      { id:"agenda",     label:"Agenda",       icon:Calendar },
  { id:"prontuarios",label:"Prontuários",  icon:Stethoscope },
      { id:"pacotes",    label:"Pacotes",      icon:Layers },
      { id:"painel",     label:"Painel",       icon:Activity },
      { id:"espera",     label:"Lista de espera", icon:Hourglass },
      { id:"faltas",     label:"Faltas",       icon:CalendarX },
      { id:"integracoes",label:"Integrações",  icon:Link2 },
      { id:"privacidade",label:"Privacidade",  icon:ShieldCheck },
      { id:"atividades", label:"Atividades",    icon:ListChecks },
      { id:"clientes",   label:"Clientes",      icon:UserCheck },
      { id:"calendario", label:"Calendário",    icon:Calendar },
    ]
  },
  {
    label: "Análise",
    items: [
      { id:"gestao",     label:"Gestão",        icon:Gauge },
      { id:"dashboard",  label:"Dashboard",     icon:LayoutDashboard },
      { id:"financeiro", label:"Financeiro",    icon:CreditCard },
      { id:"relatorios", label:"Relatórios",    icon:BarChart3 },
      { id:"historico",  label:"Histórico",     icon:History },
      { id:"vendas",     label:"Painel Vendas", icon:Trophy },
      { id:"comissoes",  label:"Comissões",     icon:Percent },
    ]
  },
  {
    label: "Admin",
    items: [
      { id:"financa",       label:"Finança Pessoal", icon:Wallet },
      { id:"rh",            label:"RH",              icon:UserCog },
      { id:"usuarios",      label:"Time",          icon:Users2 },
      { id:"configuracoes", label:"Configurações", icon:Settings },
    ]
  }
];

const ALL_ITEMS = NAV_SECTIONS.flatMap(s=>s.items);

function AcessoNegado() {
  const { theme } = useTheme();
  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"60vh", gap:12, fontFamily:"'Inter',sans-serif" }}>
      <div style={{ fontSize:40 }}>🔒</div>
      <div style={{ fontSize:16, fontWeight:600, color:theme.text }}>Acesso Restrito</div>
      <div style={{ fontSize:13, color:theme.textMuted }}>Você não tem permissão para esta página.</div>
    </div>
  );
}

function AppInner() {
  const { theme, toggleTheme } = useTheme();
  const [user, setUser] = useState(()=>{ try{ return JSON.parse(localStorage.getItem("crm_user")); }catch{ return null; } });
  const [page, setPage] = useState("negociacoes");
  const [leadParaAbrir, setLeadParaAbrir] = useState(null);
  const [orcPrefill, setOrcPrefill] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [agencia, setAgencia] = useState(()=>{ try{ return JSON.parse(localStorage.getItem("agencia_dados"))||{}; }catch{ return {}; } });
  const [empresa, setEmpresa] = useState(()=>{ try{ return JSON.parse(localStorage.getItem("crm_empresa")); }catch{ return null; } });
  const [master, setMaster] = useState(false);
  const { notifs, adicionar, limpar } = useNotificacoes();

  useEffect(()=>{
    const h=(e)=>setAgencia(e.detail||{});
    window.addEventListener("agencia_atualizada",h);
    return()=>window.removeEventListener("agencia_atualizada",h);
  },[]);

  useEffect(()=>{ if(!user) return; import("./api").then(m=>{ m.default.get("/auth/me").then(r=>{ setMaster(!!(r.data && r.data.master)); if(r.data && r.data.empresa){ setEmpresa(r.data.empresa); try{ localStorage.setItem("crm_empresa", JSON.stringify(r.data.empresa)); }catch(e){} limparVocab(); } }).catch(()=>{}); }); },[user]);

  const handleLogin=(u)=>{ setUser(u); setPage("negociacoes"); try{ localStorage.removeItem("crm_funil"); }catch(e){} limparVocab(); marca(true); };
  const handleLogout=()=>{ localStorage.removeItem("crm_token"); localStorage.removeItem("crm_user"); localStorage.removeItem("crm_empresa"); localStorage.removeItem("crm_funil"); limparMarca(); limparVocab(); setUser(null); setEmpresa(null); };
  const handleUserUpdate=(u)=>{ const m={...(JSON.parse(localStorage.getItem("crm_user")||"{}")), ...u}; setUser(m); localStorage.setItem("crm_user",JSON.stringify(m)); };

  if (!user) {
    const naCadastro = /^\/(cadastro|signup)/.test(window.location.pathname);
    if (naCadastro) return <Signup onLogin={(u,emp)=>{ if(emp) setEmpresa(emp); try{ window.history.replaceState(null,"","/"); }catch(e){} handleLogin(u); }}/>;
    return (<>
      <Login onLogin={handleLogin} agencia={agencia}/>
    </>);
  }

  const trialAteD = empresa && empresa.trialAte ? new Date(empresa.trialAte) : null;
  const diasTrial = empresa && empresa.status==="trial" && trialAteD ? Math.ceil((trialAteD - new Date())/86400000) : null;
  const contaBloqueada = !!empresa && (empresa.ativo===false || empresa.status==="bloqueada" || (diasTrial!==null && diasTrial<=0));
  if (contaBloqueada) return (
    <div style={{position:"fixed",inset:0,zIndex:9999,overflowY:"auto",display:"flex",alignItems:"center",justifyContent:"center",background:"#f6f6f8",fontFamily:"Inter, sans-serif",padding:16}}>
      <div style={{maxWidth:440,background:"#fff",borderRadius:15,padding:32,textAlign:"center",boxShadow:"0 8px 30px rgba(0,0,0,.08)"}}>
        <h2 style={{margin:0,color:"#111"}}>{empresa.status==="trial" ? "Seu período de teste terminou" : "Conta bloqueada"}</h2>
        <p style={{color:"#555",fontSize:15,lineHeight:1.5}}>Seus dados estão guardados. Para continuar usando o CRM, fale com a gente e ative sua assinatura.</p>
        <button onClick={handleLogout} style={{marginTop:10,padding:"12px 24px",border:0,borderRadius:10,background:"#EE6A1A",color:"#fff",fontWeight:700,fontSize:15,cursor:"pointer"}}>Sair</button>
      </div>
    </div>
  );
  const perfil      = getPerfil(user.role);
  const modulosEmp = empresa && Array.isArray(empresa.modulos) ? empresa.modulos : null;
  const moduloOn = (id)=> !modulosEmp || modulosEmp.length===0 || modulosEmp.includes(id);
  // telas que so existem na clinica
const SO_NA_CLINICA = ["prontuarios", "pacotes", "agenda", "faltas", "espera", "painel"];
// telas que nao fazem sentido para clinica
const FORA_DA_CLINICA = ["projetos", "projeto-central", "projetocentral", "projetoCentral", "vendas", "comissoes", "financa", "financa-pessoal", "dashboard"];
const soClinica = (i) => {
  const clinica = ehSegmentoClinica();
  if (SO_NA_CLINICA.indexOf(i.id) !== -1) return clinica;
  if (FORA_DA_CLINICA.indexOf(i.id) !== -1) return !clinica;
  return true;
};
  const navSections = NAV_SECTIONS.map(s=>({ ...s, items: s.items.filter(i=>perfil.paginas.includes(i.id) && moduloOn(i.id) && soClinica(i)) })).filter(s=>s.items.length>0);
  if (master) navSections.push({ label:"Plataforma", items:[{ id:"master", label:"Painel Master", icon:Shield }] });
  const paginaAtual = ALL_ITEMS.find(n=>n.id===page) || (page==="master" ? { id:"master", label:"Painel Master" } : undefined);
  const SUBTITULOS = {
    negociacoes:"Acompanhe suas oportunidades de venda",
    leads:"Gerencie seus contatos e prospecções",
    kanban:"Visualize seu funil de vendas",
    clientes: ehSegmentoClinica() ? "Pacientes cadastrados" : "Sua carteira de clientes",
    projetos:"Projetos em andamento",
    calendario:"Sua agenda e compromissos",
    dashboard:"Visão geral do negócio",
    financeiro:"Controle de receitas e despesas",
    vendas:"Desempenho da equipe",
    comissoes:"Calculadora e regras de comissão",
    financa:"Suas finanças pessoais",
    usuarios:"Gerencie os usuários",
    configuracoes:"Ajustes do sistema",
  };
  const dataHoje = new Date().toLocaleDateString("pt-BR");
  const temPerm     = (id)=>perfil.paginas.includes(id);

  const ORANGE = "#E8520A";
  const W_OPEN = 220;
  const W_CLOSED = 56;

  return (
    <div style={{ display:"flex", minHeight:"100vh", background:"#F7F8FA", fontFamily:"'Inter',-apple-system,sans-serif" }}>

      {/* ── SIDEBAR ── */}
      <aside style={{
        width: collapsed ? W_CLOSED : W_OPEN,
        minWidth: collapsed ? W_CLOSED : W_OPEN,
        height:"100vh", position:"fixed", top:0, left:0, bottom:0, zIndex:50,
        background:"#383A40",
        borderRight:"1px solid #2A2C31",
        display:"flex", flexDirection:"column",
        transition:"width .2s ease, min-width .2s ease",
        overflow:"hidden",
        boxShadow:"2px 0 12px rgba(0,0,0,.04)",
      }}>

        {/* Logo */}
        <div style={{ padding: collapsed?"14px 12px":"14px 16px", display:"flex", alignItems:"center", gap:10, minHeight:58, borderBottom:"1px solid rgba(255,255,255,.06)" }}>
          <div style={{ width:40, height:40, borderRadius:11, flexShrink:0, background:"linear-gradient(135deg,#F97316,#EA580C)", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 2px 8px rgba(249,115,22,.4)" }}>
            {marcaSync().logo
              ? <img src={marcaSync().logo} alt="" style={{ width:"100%", height:"100%", objectFit:"cover", borderRadius:11 }}/>
              : <svg width="21" height="21" viewBox="0 0 24 24" fill="#fff"><path d="M13 2 3 14h7l-1 8 10-12h-7z"/></svg>}
          </div>
          {!collapsed&&(
            <div style={{ flex:1, overflow:"hidden" }}>
              <div style={{ fontSize:13, fontWeight:700, color:"#FFFFFF", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", letterSpacing:"-.02em" }}>
                {marcaSync().nome || "CRM"}
              </div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,.5)", marginTop:1 }}>CRM de Vendas</div>
            </div>
          )}
          {!collapsed&&(
            <button onClick={()=>setCollapsed(true)} style={{ background:"none", border:"none", color:"rgba(255,255,255,.55)", cursor:"pointer", padding:4, borderRadius:6, fontSize:13, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center" }}
              onMouseEnter={e=>{ e.currentTarget.style.background="rgba(255,255,255,.1)"; e.currentTarget.style.color="#FFFFFF"; }}
              onMouseLeave={e=>{ e.currentTarget.style.background="none"; e.currentTarget.style.color="rgba(255,255,255,.55)"; }}>
              ◀
            </button>
          )}
          {collapsed&&(
            <button onClick={()=>setCollapsed(false)} style={{ position:"absolute", left:0, right:0, bottom:0, background:"none", border:"none", color:"rgba(255,255,255,.55)", cursor:"pointer", padding:"6px 0", fontSize:11, display:"flex", alignItems:"center", justifyContent:"center" }}
              onMouseEnter={e=>{ e.currentTarget.style.color="#FFFFFF"; }}
              onMouseLeave={e=>{ e.currentTarget.style.color="rgba(255,255,255,.55)"; }}>
              ▶
            </button>
          )}
        </div>

        {/* Nav */}
        <div style={{ flex:1, overflowY:"auto", padding: collapsed?"8px 8px":"8px 10px" }}>
          {collapsed ? (
            // Modo ícone
            <div style={{ display:"flex", flexDirection:"column", gap:2 }}>
              {NAV_SECTIONS.flatMap(s=>s.items).filter(i=>perfil.paginas.includes(i.id) && soClinica(i)).map(item=>{
                const active = page===item.id;
                return (
                  <button key={item.id} onClick={()=>setPage(item.id)} title={t(item.label)}
                    style={{ width:40, height:36, borderRadius:9, border:"none", background:active?"linear-gradient(135deg,#F97316,#EA580C)":"transparent", color:active?"#FFFFFF":"rgba(255,255,255,.7)", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, margin:"0 auto", transition:"all .1s" }}
                    onMouseEnter={e=>{ if(!active) e.currentTarget.style.background="rgba(255,255,255,.05)"; }}
                    onMouseLeave={e=>{ e.currentTarget.style.background=active?"linear-gradient(135deg,#F97316,#EA580C)":"transparent"; }}>
                    {item.icon&&<item.icon size={19}/>}
                  </button>
                );
              })}
            </div>
          ) : (
            navSections.map((section,si)=>(
              <div key={si} style={{ marginBottom:10 }}>
                <div style={{ padding:"12px 8px 4px", fontSize:10, fontWeight:700, color:"rgba(255,255,255,.5)", textTransform:"uppercase", letterSpacing:".09em", letterSpacing:".07em" }}>{section.label}</div>
                {section.items.map(item=>{
                  const active = page===item.id;
                  return (
                    <button key={item.id} onClick={()=>setPage(item.id)}
                      style={{ width:"100%", display:"flex", alignItems:"center", gap:10, padding:"9px 11px", borderRadius:9, marginBottom:2, cursor:"pointer", border:"none", background:active?"linear-gradient(135deg,#F97316,#EA580C)":"transparent", color:active?"#FFFFFF":"rgba(255,255,255,.62)", fontWeight:active?600:400, fontSize:13, transition:"all .1s", fontFamily:"'Inter',sans-serif", textAlign:"left", letterSpacing:"-.01em", boxShadow:active?"0 3px 10px rgba(249,115,22,.35)":"none" }}
                      onMouseEnter={e=>{ if(!active){ e.currentTarget.style.background="rgba(255,255,255,.05)"; e.currentTarget.style.color="#FFFFFF"; } }}
                      onMouseLeave={e=>{ e.currentTarget.style.background=active?"linear-gradient(135deg,#F97316,#EA580C)":"transparent"; e.currentTarget.style.color=active?"#FFFFFF":"rgba(255,255,255,.62)"; }}>
                      <span style={{ display:"flex", alignItems:"center", flexShrink:0 }}>{item.icon&&<item.icon size={18}/>}</span>
                      <span style={{ flex:1 }}>{t(item.label)}</span>
                      
                    </button>
                  );
                })}
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {!collapsed&&(
          <div style={{ padding:"10px 10px 12px", borderTop:"1px solid rgba(255,255,255,.08)" }}>
            <div style={{ display:"flex", alignItems:"center", gap:9, padding:"8px 10px", borderRadius:10, background:"rgba(255,255,255,.06)", marginBottom:8, cursor:"pointer" }}
              onClick={()=>setPage("configuracoes")}
              onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,.12)"}
              onMouseLeave={e=>e.currentTarget.style.background="rgba(255,255,255,.06)"}>
              <div style={{ width:28, height:28, borderRadius:8, background:`linear-gradient(135deg,${perfil.color}22,${perfil.color}44)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, flexShrink:0 }}>
                {perfil.emoji}
              </div>
              <div style={{ flex:1, overflow:"hidden" }}>
                <div style={{ fontSize:12, fontWeight:600, color:"#FFFFFF", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{user.nome?.split(" ")[0]}</div>
                <div style={{ fontSize:10, color:perfil.color, fontWeight:600 }}>{perfil.label}</div>
              </div>
            </div>
            <div style={{ display:"flex", gap:4 }}>
              <button onClick={toggleTheme} title="Alternar tema" style={{ flex:1, height:28, borderRadius:7, border:"1px solid rgba(255,255,255,.12)", background:"transparent", color:"rgba(255,255,255,.6)", cursor:"pointer", fontSize:12, display:"flex", alignItems:"center", justifyContent:"center" }}
                onMouseEnter={e=>{ e.currentTarget.style.background="rgba(255,255,255,.1)"; e.currentTarget.style.color="#FFFFFF"; }}
                onMouseLeave={e=>{ e.currentTarget.style.background="transparent"; e.currentTarget.style.color="rgba(255,255,255,.6)"; }}>
                {theme.name==="dark"?"☀️":"🌙"}
              </button>
              <button onClick={handleLogout} title="Sair" style={{ flex:1, height:28, borderRadius:7, border:"1px solid rgba(255,255,255,.12)", background:"transparent", color:"rgba(255,255,255,.6)", cursor:"pointer", fontSize:12, display:"flex", alignItems:"center", justifyContent:"center" }}
                onMouseEnter={e=>{ e.currentTarget.style.background="#FEE8E8"; e.currentTarget.style.color="#E2445C"; e.currentTarget.style.borderColor="#FBBCCA"; }}
                onMouseLeave={e=>{ e.currentTarget.style.background="transparent"; e.currentTarget.style.color="rgba(255,255,255,.6)"; e.currentTarget.style.borderColor="rgba(255,255,255,.12)"; }}>
                ⏻
              </button>
            </div>
          </div>
        )}
      </aside>

      {/* ── MAIN ── */}
      <div style={{ flex:1, marginLeft: collapsed?W_CLOSED:W_OPEN, transition:"margin-left .2s ease", display:"flex", flexDirection:"column", minHeight:"100vh" }}>

        {/* Topbar */}
        <header style={{ height:52, background:"#FFFFFF", borderBottom:"1px solid #ECEEF2", display:"flex", alignItems:"center", padding:"0 24px", position:"sticky", top:0, zIndex:40, boxShadow:"0 1px 4px rgba(0,0,0,.03)" }}>
          {/* titulo do topo removido (evita nome duplicado) */}
          <div style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:8 }}>
            <VoltarMaster/>
            <SinoAvisos onAbrir={()=>setPage("leads")}/>
            <div style={{ fontSize:13, color:"#9499A5" }}>
              Olá, <span style={{ color:"#1A1D23", fontWeight:600 }}>{user.nome?.split(" ")[0]}</span>
            </div>
            <span style={{ fontSize:11, background:perfil.color+"15", color:perfil.color, padding:"3px 10px", borderRadius:99, fontWeight:700, letterSpacing:".01em" }}>
              {perfil.label}
            </span>
          </div>
        </header>

        {/* Cabeçalho de página (oculto em páginas com título próprio) */}
        {!["orcamentos","produtos","gestao","integracoes","privacidade","dashboard","relatorios","historico","vendas","master"].includes(page) && (
        <div style={{ display:"flex", alignItems:"flex-start", padding:"22px 24px 16px", background:"var(--page-bg)" }}>
          <div>
            <div style={{ fontSize:24, fontWeight:700, color:"var(--text-primary)", letterSpacing:"-.02em", lineHeight:1.1 }}>{t(paginaAtual?.label)}</div>
            {SUBTITULOS[page]&&<div style={{ fontSize:13.5, color:"var(--text-secondary)", marginTop:3 }}>{SUBTITULOS[page]}</div>}
          </div>
          <div style={{ marginLeft:"auto", textAlign:"right" }}>
            <div style={{ fontSize:20, fontWeight:700, color:"#EE6A1A", letterSpacing:"-.01em" }}>{dataHoje}</div>
            <div style={{ fontSize:10, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".06em", marginTop:1 }}>Hoje</div>
          </div>
        </div>
        )}

        {/* Páginas */}
        <main style={{ flex:1, overflow:"auto" }}>
          {page==="leads"        && (temPerm("leads")        ? <Leads        currentUser={user}/> : <AcessoNegado/>)}
          {page==="kanban"       && (temPerm("kanban")       ? <Kanban       onStageChange={adicionar} leadIdParaAbrir={leadParaAbrir} currentUser={user}/> : <AcessoNegado/>)}
          {page==="negociacoes"  && (temPerm("negociacoes")  ? <Negociacoes  currentUser={user} irParaOrcamento={(pre)=>{ setOrcPrefill(pre); setPage("orcamentos"); }}/> : <AcessoNegado/>)}
          {page==="atividades"   && (temPerm("atividades")   ? <Atividades   currentUser={user}/> : <AcessoNegado/>)}
          {page==="projetos"     && (temPerm("projetos")     ? <Projetos     currentUser={user}/> : <AcessoNegado/>)}
          {page==="financeiro"   && (temPerm("financeiro")   ? <Financeiro   currentUser={user}/> : <AcessoNegado/>)}
          {page==="relatorios"   && (temPerm("financeiro")   ? <Relatorios   currentUser={user}/> : <AcessoNegado/>)}
          {page==="orcamentos"   && <Orcamentos   currentUser={user} prefill={orcPrefill} onPrefillUsado={()=>setOrcPrefill(null)}/>}
          {page==="produtos"     && <Produtos     currentUser={user}/>}
          {page==="pacotes"      && <Pacotes      currentUser={user}/>}
          {page==="integracoes"  && <Integracoes  currentUser={user}/>}
          {page==="faltas"       && <Faltas       currentUser={user}/>}
          {page==="espera"       && <Espera       currentUser={user}/>}
          {page==="prontuarios"       && <Prontuarios currentUser={user}/>}
          {page==="privacidade"  && <Privacidade currentUser={user}/>}
          {page==="painel"       && <Painel       currentUser={user}/>}
          {page==="agenda"       && <Agenda       currentUser={user}/>}
          {page==="historico"    && <Historico    currentUser={user}/>}
          {page==="calendario"   && (temPerm("calendario")   ? <Calendario   onAbrirLead={(id)=>{ setLeadParaAbrir(id); setPage("kanban"); }}/> : <AcessoNegado/>)}
          {page==="gestao"       && (temPerm("gestao")       ? <Gestao       currentUser={user}/> : <AcessoNegado/>)}
          {page==="dashboard"    && (temPerm("dashboard")    ? <Dashboard/> : <AcessoNegado/>)}
          {page==="vendas"       && (temPerm("vendas")       ? <PainelVendas currentUser={user}/> : <AcessoNegado/>)}
          {page==="comissoes"    && <Comissoes    currentUser={user}/>}
          {page==="clientes"     && (temPerm("clientes")     ? <Clientes     currentUser={user}/> : <AcessoNegado/>)}
          {page==="financa"      && (temPerm("financa")      ? <FinancaPessoal currentUser={user}/> : <AcessoNegado/>)}
          {page==="rh"           && (temPerm("rh")           ? <RH/> : <AcessoNegado/>)}
          {page==="usuarios"     && (temPerm("usuarios")     ? <Usuarios     currentUser={user}/> : <AcessoNegado/>)}
          {page==="master" && master && <PainelMaster/>}
          {page==="configuracoes"&& (temPerm("configuracoes")? <><Configuracoes user={user} onUserUpdate={handleUserUpdate} currentUser={user}/><FunilConfig/></> : <AcessoNegado/>)}
        </main>
      </div>

      <NotificacaoToast notifs={notifs} limpar={limpar}/>
    </div>
  );
}

export default function App() {
  return <ThemeProvider><AppInner/></ThemeProvider>;
}
